import { makeStyles } from "@material-ui/core/styles";
import React from "react";
export interface CourierNameProps {
  courierName: string | null;
}

const useStyles = makeStyles(
  {
    courierNameText: {
      color: "#747C8C",
      fontSize: 16
    }
  },
  { name: "CourierName" }
);

const CourierName: React.FC<CourierNameProps> = props => {
  const classes = useStyles(props);
  const { courierName } = props;

  return (
    <div className={classes.courierNameText}>
      <span>{courierName}</span>
    </div>
  );
};

export default CourierName;
